import * as yup from 'yup';

import { FormErrors } from '@blockpulse3/data/shared';
import { getUserTimezone } from '@blockpulse3/helpers';
import { requiredEmailField } from '@blockpulse3/web-client/forms';

import { ISignUpForm } from './types';

export const schema = yup
  .object({
    email: requiredEmailField,
    password: yup
      .string()
      .trim()
      .min(8, FormErrors.PasswordFormat)
      .required(FormErrors.RequiredField),
    confirmPassword: yup
      .string()
      .trim()
      .test(
        'password-confirmation',
        'PASSWORD_MATCH',
        (value, context) => value === context.parent.password,
      )
      .required(FormErrors.RequiredField),
    conditions: yup.boolean().isTrue('CONDITIONS_FIELD').required(FormErrors.RequiredField),
  })
  .required() as yup.ObjectSchema<ISignUpForm>;

export const signUpFormDefaults: ISignUpForm = {
  email: '',
  password: '',
  confirmPassword: '',
  conditions: false,
  timezone: getUserTimezone(),
};
